/**
 * return localized url
 *
 * @param string url
 * @param string locale
 *
 */

export const getLocalizeUrl = (url, locale) => {
  if (!url) return '/';

  return !locale || locale === 'en_US' || locale === 'zh_CN' ? url : `/${locale}${url}`;
};

export const getLocalizeRootUrl = (root, locale, path) => {
  const newPath = path || '';
  return !locale || locale === 'en_US' || locale === 'zh_CN'
    ? `${root}${newPath}`
    : `${root}/${locale}${newPath}`;
};

/**
 * return url with rn query
 *
 * @param string url
 * @param string rn
 *
 */
export const getUrlWithRn = (url = '/', rn = '') => {
  return `${url}?rn=${rn}`;
};

/**
 * return localized url with rn query
 *
 * @param string url
 * @param string locale
 * @param string rn
 * @param bool noRedirect
 *
 */

export const getFormattedUrl = (url, locale, rn, appendNoRedirect = false) => {
  const formattedUrl = getLocalizeUrl(url, locale);

  const redirect = appendNoRedirect && locale !== 'en_US' ? '&redirect=no' : '';

  return `${getUrlWithRn(formattedUrl, rn)}${redirect}`;
};
